import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useMongoDBFunctions() {
  const { getItemsAggregate, getItemAndUpdate, getItems } = useLambda()

  const processesQueryWithOffset = async ({ query, offset, limit, total, search, sortBy, sortOrder, client_id = '', role, worker_id }) => {
    let processes = []
    let totalRecords = 0
    let pipeline = []
    // let model = ''

    // The supervisor condition is not necessary because the processes for supervisors are already being filtered with MongoDB Atlas rules

    // Fetch only the processes related to the supervisor and workers supervised roles
    // if (role === "supervisor") {
    //   model = mongodb.db("development").collection("worker");
    //   const supervisorID = oid(worker_id)

    //   pipeline = [
    //     {
    //       $match:
    //         {
    //           $or: [
    //             {
    //               supervisors: supervisorID,
    //               deleted: { $ne: true },
    //             },
    //             {
    //               _id: supervisorID,
    //             },
    //           ],
    //         },
    //     },
    //     {
    //       $unwind:
    //         {
    //           path: "$roles",
    //         },
    //     },
    //     {
    //       $group:
    //         {
    //           _id: "$roles",
    //         },
    //     },
    //     {
    //       $lookup:
    //         {
    //           from: "confirmation_planning",
    //           localField: "_id",
    //           foreignField: "role",
    //           as: "processes",
    //           pipeline: [
    //             {
    //               $match: {
    //                 deleted: {
    //                   $ne: true,
    //                 },
    //               },
    //             },
    //             {
    //               $project: {
    //                 _id: 0,
    //                 process: 1,
    //               },
    //             },
    //           ],
    //         },
    //     },
    //     {
    //       $unwind:
    //         {
    //           path: "$processes",
    //         },
    //     },
    //     {
    //       $group:
    //         {
    //           _id: "$processes.process",
    //         },
    //     },
    //     {
    //       $lookup:
    //         {
    //           from: "process",
    //           localField: "_id",
    //           foreignField: "_id",
    //           as: "processData",
    //           pipeline: [
    //             {
    //               $match: {
    //                 deleted: {
    //                   $ne: true,
    //                 },
    //               },
    //             },
    //             {
    //               $lookup: {
    //                 from: "crime",
    //                 localField: "crimes",
    //                 foreignField: "_id",
    //                 as: "crimesData",
    //                 pipeline: [
    //                   {
    //                     $project: {
    //                       _id: 0,
    //                       name: 1
    //                     }
    //                   }
    //                 ]
    //               }
    //             },
    //             {
    //               $project: {
    //                 name: 1,
    //                 goal: 1,
    //                 description: 1,
    //                 activities: 1,
    //                 requireImage: 1,
    //                 metadata: 1,
    //                 crimesData: 1,
    //                 code: 1,
    //                 evaluated: 1,
    //               },
    //             },
    //           ],
    //         },
    //     },
    //     {
    //       $unwind:
    //         {
    //           path: "$processData",
    //         },
    //     },
    //     {
    //       $replaceRoot:
    //         {
    //           newRoot: "$processData",
    //         },
    //     }
    //   ]
    // } else {      
      pipeline = [
        {
          $match:
            {
              deleted: { $ne: true },
              client_id: oid(client_id)
            },
        },
        {
          $lookup: {
            from: "crime",
            localField: "crimes",
            foreignField: "_id",
            as: "crimesData",
            pipeline: [
              {
                $project: {
                  _id: 0,
                  name: 1
                }
              }
            ]
          }
        },
        {
          $project: {
            name: 1,
            goal: 1,
            description: 1,
            activities: 1,
            requireImage: 1,
            metadata: 1,
            crimesData: 1,
            code: 1,
            evaluated: 1,
          }
        }
      ]
    // }

    pipeline.push(
      {
        $lookup: {
          from: "metadata",
          localField: "metadata",
          foreignField: "_id",
          as: "metadataData",
          pipeline: [
            {
              $match: {
                deleted: {
                  $ne: true,
                }
              }
            },
            {
              $project: {
                name: 1,
                type: 1,
              }
            }
          ]
        }
      }
    )

    if (search) {
      pipeline.push(
        {
          $match: {
            $or: [
              {
                name: {
                  $regex: search,
                  $options: "i",
                },
              },
            ],
          },
        }
      )
    }

    let pipelineCount = [
      ...pipeline,
      {
        $count: "count"
      }
    ]

    pipeline.push(
      {
        $sort: {
          [sortBy]: sortOrder || 1,
          _id: sortOrder || 1
        }
      },
      {
        $skip: offset || 0
      },
      {
        $limit: limit || 10
      }
    )

    processes = await getItemsAggregate({ collection: 'process', pipeline })
    if (total) {
      const totalArray = await getItemsAggregate({ collection: 'process', pipeline: pipelineCount })
      totalRecords = totalArray.length ? totalArray[0].count : 0;
    }
    
    return {
      processes,
      totalRecords
    }
  }

  const complaintsQueryWithOffset = async ({ client_id, search, sortBy, sortOrder, limit, offset, state, stage, onlyPendingTasks, type, companies, workerId, workerName, workerEmail, restrictToOwn }) => {
    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)

    const filter = {
      client_id: oid(client_id),
      deleted: { $ne: true },
      reportedPerson: { $ne: oid(workerId) },    // condition for type economic crimes law / ethical situations
      $or: [      // condition for type karin law
        {
          "reportedPersonData.email": { $ne: workerEmail, $nin: [null, ""] }
        },
        {
          "reportedPersonData.email": { $in: [null, ""] },
          "reportedPersonData.name": { $ne: workerName }
        }
      ]
    }

    // Guardar las condiciones de investigador para combinarlas luego con el filtro de responsables
    let investigatorConditions = null

    // Construir condiciones de investigador cuando restrictToOwn está activo
    if (restrictToOwn && workerId) {
      // Obtener empresas donde el usuario es investigador
      const companiesWithInvestigators = await getItems({
        collection: 'company',
        query: {
          client_id: oid(client_id),
          deleted: { $ne: true },
          $or: [
            { economicCrimesLawMainInvestigators: oid(workerId) },
            { economicCrimesLawSecondaryInvestigators: oid(workerId) },
            { karinLawMainInvestigators: oid(workerId) },
            { karinLawSecondaryInvestigators: oid(workerId) },
            { ethicalSituationsMainInvestigators: oid(workerId) },
            { ethicalSituationsSecondaryInvestigators: oid(workerId) }
          ]
        },
        options: {
          projection: {
            _id: 1,
            economicCrimesLawMainInvestigators: 1,
            economicCrimesLawSecondaryInvestigators: 1,
            karinLawMainInvestigators: 1,
            karinLawSecondaryInvestigators: 1,
            ethicalSituationsMainInvestigators: 1,
            ethicalSituationsSecondaryInvestigators: 1
          }
        }
      })

      // Construir filtro de combinaciones empresa+tipo permitidas
      const allowedConditions = []
      const workerIdStr = workerId.toString ? workerId.toString() : workerId

      companiesWithInvestigators.forEach(company => {
        const companyId = company._id
        const companyIdStr = companyId.toString()

        // Verificar en qué tipos está asignado
        const isEconomicCrimesInvestigator =
          company.economicCrimesLawMainInvestigators?.some(id => id.toString() === workerIdStr) ||
          company.economicCrimesLawSecondaryInvestigators?.some(id => id.toString() === workerIdStr)

        const isKarinInvestigator =
          company.karinLawMainInvestigators?.some(id => id.toString() === workerIdStr) ||
          company.karinLawSecondaryInvestigators?.some(id => id.toString() === workerIdStr)

        const isEthicalInvestigator =
          company.ethicalSituationsMainInvestigators?.some(id => id.toString() === workerIdStr) ||
          company.ethicalSituationsSecondaryInvestigators?.some(id => id.toString() === workerIdStr)

        // Agregar condiciones para cada tipo donde es investigador
        // Guardamos tanto el ObjectId para MongoDB como el string para comparación
        if (isEconomicCrimesInvestigator) {
          allowedConditions.push({ company: oid(companyId), companyStr: companyIdStr, type: 'economicCrimesLaw' })
        }
        if (isKarinInvestigator) {
          allowedConditions.push({ company: oid(companyId), companyStr: companyIdStr, type: 'karinLaw' })
        }
        if (isEthicalInvestigator) {
          allowedConditions.push({ company: oid(companyId), companyStr: companyIdStr, type: 'ethicalSituations' })
        }
      })

      // Si hay condiciones permitidas, guardarlas para combinar luego
      if (allowedConditions.length > 0) {
        // Si hay filtro de empresas desde el navbar, combinar ambos
        if (companies && companies.length > 0) {
          // Convertir IDs del navbar a strings para comparación
          const selectedCompanyIds = companies.map(id => {
            const idStr = typeof id === 'string' ? id : id.toString()
            return idStr
          })

          // Filtrar solo las condiciones de las empresas seleccionadas usando companyStr
          const filteredConditions = allowedConditions.filter(cond => {
            return selectedCompanyIds.includes(cond.companyStr)
          })

          if (filteredConditions.length > 0) {
            // Guardar para combinar luego con el filtro de responsables
            investigatorConditions = filteredConditions.map(c => ({ company: c.company, type: c.type }))
          } else {
            // Empresa seleccionada pero usuario no es investigador de esa empresa
            // y tampoco es responsable, entonces no debe ver nada
            investigatorConditions = []
          }
        } else {
          // No hay filtro de empresas, guardar todas las condiciones de investigador
          investigatorConditions = allowedConditions.map(c => ({ company: c.company, type: c.type }))
        }
      } else {
        // No es investigador de ninguna empresa+tipo
        investigatorConditions = []
      }
    } else {
      // Si no está restringido, aplicar filtro normal de empresas
      if (companies && companies.length > 0) {
        filter.company = { $in: companies.map(id => oid(id)) }
      }
    }

    if (stage) filter.stage = stage

    // 🔹 Nuevo bloque de búsqueda
    const complaintThemes = {
      workplace_harassment: "Acoso laboral",
      sexual_harassment: "Acoso sexual",
      injuries: "Lesiones",
      adulteration_of_financial_statements: "Adulteración de estados financieros",
      misappropriation: "Apropiación indebida",
      accounting_and_audit_matters: "Asuntos contables y de auditoría",
      incorrect_conduct_or_inappropriate_behavior: "Conducta incorrecta o comportamiento inadecuado",
      interest_conflict: "Conflicto de interés",
      corruption_among_private_individuals: "Corrupción entre privados",
      corruption_crime: "Delito de cohecho",
      bribery_crime: "Delito de soborno",
      discrimination: "Discriminación",
      workplace_discrimination: "Discriminación laboral",
      terrorist_financing: "Financiamiento del terrorismo",
      fraud: "Fraude",
      policy_violations: "Infracciones a las políticas",
      money_laundering: "Lavado de dinero",
      environmental_protection_law: "Ley de protección del medio ambiente",
      misuse_of_resources: "Mal uso de recursos",
      environment: "Medio ambiente",
      receiving: "Receptación",
      robbery_or_theft: "Robo o hurto",
      occupational_health_and_safety: "Seguridad y salud ocupacional",
      ti: "TI",
      use_of_privileged_or_confidential_information: "Uso de información privilegiada o confidencial",
      violence_at_work: "Violencia en el trabajo"
    }

    if (search) {
      const searchLower = search.toLowerCase();
      const matchedThemes = Object.entries(complaintThemes)
        .filter(([key, translated]) => translated.toLowerCase().includes(searchLower))
        .map(([key]) => key);

      filter.$and = [
        { $or: [
            { caseNumber: { $regex: search, $options: "i" } },
            ...(matchedThemes.length > 0 ? [{ "themes.value": { $in: matchedThemes } }] : [])
          ]
        }
      ]
    }

    if (type) filter.type = type

    const pipeline = [
      {
        $match: filter
      },
      {
        $lookup: {
          from: "action_plan",
          localField: "actionPlans",
          foreignField: "_id",
          pipeline: [
            {
              $project: {
                _id: 0,
                stage: 1,
                endDate: 1,
                executionResponsible: 1
              }
            }
          ],
          as: "actionPlanStages"
        }
      },
      {
        $lookup: {
          from: "company",
          localField: "company",
          foreignField: "_id",
          pipeline: [
            {
              $project: {
                name: 1
              }
            }
          ],
          as: "companyData"
        }
      },
      {
        $addFields: {
          companyName: { $arrayElemAt: ["$companyData.name", 0] },
          state: {
            $switch: {
              branches: [
                {
                  case: { $eq: ["$stage", "end"] },
                  then: "completed"
                },
                {
                  case: { $in: ["$stage", ["registration", "analysis"]] },
                  then: {
                    $cond: [
                      { $and: ["$dueDate", { $lt: ["$dueDate", date(startOfToday)] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "approval"] },
                  then: {
                    $cond: [
                      { $and: ["$approvalDueDate", { $lt: ["$approvalDueDate", date(startOfToday)] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "corrective"] },
                  then: {
                    $cond: [
                      {
                        $anyElementTrue: {
                          $map: {
                            input: "$actionPlanStages",
                            as: "plan",
                            in: {
                              $cond: [
                                { $ifNull: ["$$plan.endDate", false] },
                                { $lte: ["$$plan.endDate", date(startOfToday)] },
                                false
                              ]
                            }
                          }
                        }
                      },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "verification"] },
                  then: {
                    $cond: [
                      { $and: ["$verificationDueDate", { $lt: ["$verificationDueDate", date(startOfToday)] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                }
              ],
              default: "upToDate"
            }
          }
        }
      },
      {
        $project: {
          themes: 1,
          caseNumber: 1,
          dueDate: 1,
          approvalDueDate: 1,
          verificationDueDate: 1,
          state: 1,
          stage: 1,
          isCompletedOverdue: 1,
          actionPlans: 1,
          finishData : 1,
          actionPlanStages: 1,
          type: 1,
          createdAt: 1,
          companyName: 1
        },
      },
    ]

    if (onlyPendingTasks) {
      let pendingTasksConditions = [
        {
          stage: 'analysis',
          proposalResponsible: oid(workerId)
        },
        {
          actionPlanStages: {
            $elemMatch: {
              stage: "analysis",
            }
          },
          proposalResponsible: oid(workerId)
        },
        {
          actionPlanStages: {
            $elemMatch: {
              stage: "approval",
            }
          },
          approvalResponsible: oid(workerId)
        },
        {
          actionPlanStages: {
            $elemMatch: {
              stage: "corrective",
              executionResponsible: oid(workerId),
            }
          }
        },
        {
          actionPlanStages: {
            $elemMatch: {
              stage: "verification",
            }
          },
          verificationResponsible: oid(workerId)
        }
      ]

      // Si hay filtro de empresas desde el navbar, agregar restricción de empresa a cada condición
      if (companies && companies.length > 0) {
        pendingTasksConditions = pendingTasksConditions.map(cond => ({
          ...cond,
          company: { $in: companies.map(id => oid(id)) }
        }))
      }

      pipeline.splice(2, 0,
        {
          $match: {
            $or: pendingTasksConditions
          }
        }
      )
    }

    if (restrictToOwn) {
      // Construir condiciones de responsables
      let responsibleConditions = [
        {
          proposalResponsible: oid(workerId)
        },
        {
          approvalResponsible: oid(workerId)
        },
        {
          verificationResponsible: oid(workerId)
        },
        {
          actionPlanStages: {
            $elemMatch: {
              executionResponsible: oid(workerId)
            }
          }
        }
      ]

      // Si hay filtro de empresas desde el navbar, agregar restricción de empresa a cada condición de responsable
      if (companies && companies.length > 0) {
        responsibleConditions = responsibleConditions.map(cond => ({
          ...cond,
          company: { $in: companies.map(id => oid(id)) }
        }))
      }

      // Combinar con condiciones de investigador si existen
      const orConditions = [...responsibleConditions]

      if (investigatorConditions !== null && investigatorConditions.length > 0) {
        // Agregar cada condición de investigador al $or
        investigatorConditions.forEach(invCond => {
          orConditions.push({
            company: invCond.company,
            type: invCond.type
          })
        })
      }

      // Si investigatorConditions es un array vacío, significa que el usuario no es investigador
      // de ninguna empresa+tipo, así que solo puede ver denuncias donde es responsable
      pipeline.splice(2, 0, {
        $match: {
          $or: orConditions
        }
      });
    }

    if (state !== "total") {
      pipeline.splice(-1, 0,
        {
          $match: {
            state: state
          }
        }
      )
    }

    pipeline.push(
      {
        $facet: {
          stateCounts: [
            {
              $group: {
                _id: "$state",
                count: { $sum: 1 }
              }
            },
            {
              $sort: { count: 1, _id: 1 }
            },
            {
              $group: {
                _id: null,
                labels: { $push: "$_id" },
                values: { $push: "$count" },
                statsForCards: { $push: { k: "$_id", v: "$count" } }
              }
            },
            {
              $addFields: {
                statsForCards: {
                  $arrayToObject: "$statsForCards"
                }
              }
            },
            {
              $project: {
                _id: 0,
                labels: 1,
                values: 1,
                statsForCards: 1
              }
            }
          ],
          stageCounts: [
            {
              $group: {
                _id: "$stage",
                count: { $sum: 1 }
              }
            },
            {
              $addFields: {
                order: {
                  $switch: {
                    branches: [
                      { case: { $eq: ["$_id", "registration"] }, then: 0 },
                      { case: { $eq: ["$_id", "analysis"] }, then: 1 },
                      { case: { $eq: ["$_id", "approval"] }, then: 2 },
                      { case: { $eq: ["$_id", "corrective"] }, then: 3 },
                      { case: { $eq: ["$_id", "verification"] }, then: 4 },
                      { case: { $eq: ["$_id", "correctiveMeasures"] }, then: 5 },
                      { case: { $eq: ["$_id", "implementation"] }, then: 6 },
                      { case: { $eq: ["$_id", "finalized"] }, then: 7 },
                      { case: { $eq: ["$_id", "end"] }, then: 8 }
                    ],
                    default: 6
                  }
                }
              }
            },
            {
              $sort: {
                order: 1
              }
            },
            {
              $group: {
                _id: null,
                labels: { $push: "$_id" },
                values: { $push: "$count" }
              }
            },
            {
              $project: {
                _id: 0,
                labels: 1,
                values: 1
              }
            }
          ],
          totalCount: [
            {
              $group: {
                _id: null,
                total: {
                  $sum: 1
                }
              }
            },
            {
              $project: {
                _id: 0,
                total: 1
              }
            }
          ],
          paginatedResults: [
            {
              $sort: {
                [sortBy]: sortOrder || 1,
                _id: sortOrder || 1
              }
            },
            {
              $skip: offset || 0
            },
            {
              $limit: limit || 10
            }
          ]
        }
      }
    )
    
    const results = await getItemsAggregate({ collection: 'complaint', pipeline })
    const complaintsStats = {
      stateCounts: results[0].stateCounts[0] || { labels: [], values: [], statsForCards: {} },
      stageCounts: results[0].stageCounts[0] || { labels: [], values: [] },
      totalCount: results[0].totalCount[0]?.total || 0
    };
    const complaintsPaginated = results[0].paginatedResults;

    return {
      complaintsStats,
      complaintsPaginated
    }
  }

  const getLastCode = async ({ collection, client_id }) => {
    const query = {
      collection,
      client_id: oid(client_id),
    }
    const action = { $inc: { lastCode: 1 } }
    const options = {
      upsert: true,
      returnNewDocument: false,
    }

    const result = await getItemAndUpdate({ collection: 'counter', query, action, options })

    return result?.lastCode || 0;
    
  }

  const casesQueryWithOffset = async ({ client_id, workers, search, sortBy, sortOrder, limit, offset, state, stage, onlyPendingTasks, workerId, restrictToOwn, companies, businessActivities, processes, crimes, controls, controlResponsibles }) => {
    const workerObjectId = oid(workerId)

    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)
    const dateFormatted = date(startOfToday)

    const filter = {
      client_id: oid(client_id),
      deleted: { $ne: true }
    }

    if (workers && workers.length) { filter.assignee = { "$in": workers.map(worker => oid(worker)) } }
    if (stage) filter.stage = stage

    // Global filters
    if (companies && companies.length) { filter.company = { "$in": companies.map(c => oid(c)) } }
    if (businessActivities && businessActivities.length) { filter.businessActivity = { "$in": businessActivities.map(ba => oid(ba)) } }
    if (processes && processes.length) { filter.process = { "$in": processes.map(p => oid(p)) } }
    if (crimes && crimes.length) { filter.crime = { "$in": crimes.map(c => oid(c)) } }
    if (controls && controls.length) { filter.control = { "$in": controls.map(c => oid(c)) } }
    if (controlResponsibles && controlResponsibles.length) { filter.controlResponsible = { "$in": controlResponsibles.map(cr => oid(cr)) } }

    const pipeline = [
      {
        $match: filter
      },
      {
        $lookup: {
          from: 'worker',
          localField: 'assignee',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                _id: 0,
                name: 1
              }
            }
          ],
          as: 'workerName'
        }
      },
      {
        $lookup: {
          from: "action_plan",
          localField: "actionPlans",
          foreignField: "_id",
          pipeline: [
            {
              $project: {
                _id: 0,
                stage: 1,
                endDate: 1,
                executionResponsible: 1
              }
            }
          ],
          as: "actionPlanStages"
        }
      },
      {
        $lookup: {
          from: 'company',
          localField: 'company',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                _id: 0,
                name: 1
              }
            }
          ],
          as: 'companyNames'
        }
      },
      {
        $addFields: {
          workerName: {
            $arrayElemAt: ["$workerName.name", 0],
          },
          companyNames: {
            $map: {
              input: "$companyNames",
              as: "comp",
              in: "$$comp.name"
            }
          },
          state: {
            $switch: {
              branches: [
                {
                  case: { $eq: ["$stage", "end"] },
                  then: "completed"
                },
                {
                  case: { $eq: ["$stage", "registration"] },
                  then: {
                    $cond: [
                      { $and: ["$dueDate", { $lt: ["$dueDate", dateFormatted] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "analysis"] },
                  then: {
                    $cond: [
                      { $and: ["$proposalDueDate", { $lt: ["$proposalDueDate", dateFormatted] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "approval"] },
                  then: {
                    $cond: [
                      { $and: ["$approvalDueDate", { $lt: ["$approvalDueDate", dateFormatted] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "corrective"] },
                  then: {
                    $cond: [
                      {
                        $anyElementTrue: {
                          $map: {
                            input: "$actionPlanStages",
                            as: "plan",
                            in: {
                              $cond: [
                                { $ifNull: ["$$plan.endDate", false] },
                                { $lte: ["$$plan.endDate", dateFormatted] },
                                false
                              ]
                            }
                          }
                        }
                      },
                      "delayed",
                      "upToDate"
                    ]
                  }
                },
                {
                  case: { $eq: ["$stage", "verification"] },
                  then: {
                    $cond: [
                      { $and: ["$verificationDueDate", { $lt: ["$verificationDueDate", dateFormatted] }] },
                      "delayed",
                      "upToDate"
                    ]
                  }
                }
              ],
              default: "upToDate"
            }
          }
        },
      },
      {
        $project: {
          note: 1,
          dueDate: 1,
          proposalDueDate: 1,
          approvalDueDate: 1,
          verificationDueDate: 1,
          assignee: 1,
          workerName: 1,
          companyNames: 1,
          createdAt: 1,
          state: 1,
          stage: 1,
          isCompletedOverdue: 1,
          description: 1,
          actionPlans: 1,
          actionPlanStages: 1,
          finishData: 1,
          code: 1
        },
      },
    ]

    if (onlyPendingTasks) {
      pipeline.splice(3, 0,
        {
          $match: {
            $or: [
              {
                stage: 'analysis',
                proposalResponsible: workerObjectId
              },
              {
                actionPlanStages: {
                  $elemMatch: {
                    stage: "analysis",
                  }
                },
                proposalResponsible: workerObjectId
              },
              {
                actionPlanStages: {
                  $elemMatch: {
                    stage: "approval",
                  }
                },
                approvalResponsible: workerObjectId
              },
              {
                actionPlanStages: {
                  $elemMatch: {
                    stage: "corrective",
                    executionResponsible: workerObjectId,
                  }
                }
              },
              {
                actionPlanStages: {
                  $elemMatch: {
                    stage: "verification",
                  }
                },
                verificationResponsible: workerObjectId
              }
            ]
          }
        }
      )
    }

    if (restrictToOwn) {
      pipeline.splice(3, 0, {
        $match: {
          $or: [
            {
              proposalResponsible: workerObjectId
            },
            {
              approvalResponsible: workerObjectId
            },
            {
              verificationResponsible: workerObjectId
            },
            {
              actionPlanStages: {
                $elemMatch: {
                  executionResponsible: workerObjectId
                }
              }
            }
          ]
        }
      });
    }

    if (search) {
      pipeline.push(
        {
          $addFields: {
            codeStr: { $toString: "$code" },
            companyNamesStr: { $reduce: { input: "$companyNames", initialValue: "", in: { $concat: ["$$value", " ", "$$this"] } } }
          }
        },
        {
          $match: {
            $or: [
              { note: { $regex: search, $options: 'i' } },
              { workerName: { $regex: search, $options: 'i' } },
              { codeStr: { $regex: search, $options: 'i' } },
              { companyNamesStr: { $regex: search, $options: 'i' } }
            ]
          }
        }
      )
    }

    if (state !== "total") {
      pipeline.push(
        {
          $match: {
            state: state
          }
        }
      )
    }

    pipeline.push(
      {
        $facet: {
          stateCounts: [
            {
              $group: {
                _id: "$state",
                count: { $sum: 1 }
              }
            },
            {
              $sort: { count: 1, _id: 1 }
            },
            {
              $group: {
                _id: null,
                labels: { $push: "$_id" },
                values: { $push: "$count" },
                statsForCards: { $push: { k: "$_id", v: "$count" } }
              }
            },
            {
              $addFields: {
                statsForCards: {
                  $arrayToObject: "$statsForCards"
                }
              }
            },
            {
              $project: {
                _id: 0,
                labels: 1,
                values: 1,
                statsForCards: 1
              }
            }
          ],
          stageCounts: [
            {
              $group: {
                _id: "$stage",
                count: { $sum: 1 }
              }
            },
            {
              $addFields: {
                order: {
                  $switch: {
                    branches: [
                      { case: { $eq: ["$_id", "registration"] }, then: 0 },
                      { case: { $eq: ["$_id", "analysis"] }, then: 1 },
                      { case: { $eq: ["$_id", "approval"] }, then: 2 },
                      { case: { $eq: ["$_id", "corrective"] }, then: 3 },
                      { case: { $eq: ["$_id", "verification"] }, then: 4 },
                      { case: { $eq: ["$_id", "correctiveMeasures"] }, then: 5 },
                      { case: { $eq: ["$_id", "implementation"] }, then: 6 },
                      { case: { $eq: ["$_id", "finalized"] }, then: 7 },
                      { case: { $eq: ["$_id", "end"] }, then: 8 }
                    ],
                    default: 6
                  }
                }
              }
            },
            {
              $sort: {
                order: 1
              }
            },
            {
              $group: {
                _id: null,
                labels: { $push: "$_id" },
                values: { $push: "$count" }
              }
            },
            {
              $project: {
                _id: 0,
                labels: 1,
                values: 1
              }
            }
          ],
          assigneeCounts: [
            {
              $group: {
                _id: {
                  workerName: "$workerName",
                  workerId: "$assignee"
                },
                count: { $sum: 1 }
              }
            },
            {
              $sort: { count: -1, _id: 1 }
            },
            {
              $group: {
                _id: null,
                labels: { $push: "$_id.workerName" },
                values: { $push: "$count" },
                workerIds: { $push: "$_id.workerId" }
              }
            },
            {
              $project: {
                _id: 0,
                labels: 1,
                values: 1,
                workerIds: {
                  $map: {
                    input: "$workerIds",
                    as: "id",
                    in: { $toString: "$$id" }
                  }
                }
              }
            }
          ],
          totalCount: [
            {
              $group: {
                _id: null,
                total: {
                  $sum: 1
                }
              }
            },
            {
              $project: {
                _id: 0,
                total: 1
              }
            }
          ],
          paginatedResults: [
            {
              $sort: {
                [sortBy]: sortOrder || 1,
                _id: sortOrder || 1
              }
            },
            {
              $skip: offset || 0
            },
            {
              $limit: limit || 10
            }
          ]
        }
      }
    )
    
    const results = await getItemsAggregate({ collection: 'improvement', pipeline })
    const casesStats = {
      stateCounts: results[0].stateCounts[0] || { labels: [], values: [], statsForCards: {} },
      stageCounts: results[0].stageCounts[0] || { labels: [], values: [] },
      assigneeCounts: results[0].assigneeCounts[0] || { labels: [], values: [], workerIds: [] },
      totalCount: results[0].totalCount[0]?.total || 0
    };
    const casesPaginated = results[0].paginatedResults

    return {
      casesStats,
      casesPaginated
    }
  }

  const confirmationPlanningQueryWithOffset = async ({ offset, limit, total, search, sortBy, sortOrder, client_id = '', processes, roles, evaluated, restrictToOwn, worker_id, processTypeFilter, companyFilter, idFilter }) => {
    const userObjectId = oid(worker_id)

    let totalRecordsCount = []
    let totalRecords = 0
    
    let initialFilter = {
      deleted: { $ne: true }
    }

    if (client_id) {
      initialFilter.client_id = oid(client_id)
    }

    if (processes && processes.length) {
      initialFilter.process = {
        "$in": processes.map(process => oid(process))
      }
    }

    if (roles && roles.length) {
      initialFilter.role = {
        "$in": roles.map(role => oid(role))
      }
    }

    if (evaluated && evaluated.length) {
      initialFilter.evaluated = {
        "$in": evaluated.map(evaluated => oid(evaluated))
      }
    }

    const finalFilter = {}
    const conditions = []

    // Process type filter
    if (processTypeFilter && processTypeFilter.length) {
      conditions.push({
        $or: processTypeFilter.map(codePrefix => ({
          'processData.code': { $regex: `^${codePrefix}` }
        }))
      })
    }

    // Privileges filter
    if (restrictToOwn) {
      conditions.push({
        $or: [
          { 'processData.responsibles': userObjectId },
          { 'processData.leadResponsibles': userObjectId },
          { 'processData.evaluator': userObjectId },
        ]
      })
    }

    if (companyFilter?.length > 0) {
      conditions.push({ 'processData.company': { $in: companyFilter.map(e => oid(e)) } })
    }

    if (idFilter?.length > 0) {
      conditions.push({ 'processData.id': { $in: idFilter.map(e => oid(e)) } })
    }

    // Armar el match final
    if (conditions.length) {
      finalFilter.$and = conditions
    }

    let pipeline = [
      {
        $match: initialFilter
      },
      {
        $lookup: {
          from: 'process',
          localField: 'process',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                name: 1,
                code: 1,
                responsibles: 1,
                leadResponsibles: 1,
                evaluator: 1,
                evaluated: 1,
                company: 1,
                id: 1
              }
            }
          ],
          as: 'processData'
        }
      },
      {
        $addFields: { processData: { $arrayElemAt: ["$processData", 0] }, _id: { $toString: "$_id" } }
      },
      {
        $match: finalFilter
      },
      {
        $lookup: {
          from: 'role',
          localField: 'role',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                name: 1
              }
            }
          ],
          as: 'roleName'
        }
      },
      {
        $lookup: {
          from: 'worker',
          localField: 'evaluated',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                name: 1
              }
            }
          ],
          as: 'evaluatedName'
        }
      },
    ]

    if (search) {
      pipeline.push(
        {
          $match: {
            $or: [
              {
                roleName: {
                  $elemMatch: {
                    name: {
                      $regex: search,
                      $options: 'i'
                    }
                  }
                }
              },
              {
                "processData.name": {
                  $regex: search,
                  $options: "i"
                }
              },
              {
                "processData.code": {
                  $regex: search,
                  $options: "i"
                }
              },
              {
                evaluatedName: {
                  $elemMatch: {
                    name: {
                      $regex: search,
                      $options: 'i'
                    }
                  }
                }
              }
            ]
          }
        }
      )
    }

    totalRecordsCount = await getItemsAggregate({ collection: 'confirmation_planning', pipeline })

    totalRecords = totalRecordsCount.length;

    pipeline.push(
      {
        $sort: {
          [sortBy]: sortOrder || 1,
          _id: sortOrder || 1
        }
      },
      {
        $skip: offset || 0
      },
      {
        $limit: limit || 10
      }
    )
    
    const confirmationPlannings = await getItemsAggregate({ collection: 'confirmation_planning', pipeline })

    return {
      confirmationPlannings,
      totalRecords
    }
  };

  const crimesQueryWithOffset = async ({ query, offset, limit, total, search, sortBy, sortOrder, client_id = null }) => {
    let condition = query || {};
    condition.deleted = { $ne: true };

    if (search) {
      const searchConditions = [
        { name: { $regex: search, $options: 'i' } },
        { description: { $regex: search, $options: 'i' } },
        { lawNumber: { $regex: search, $options: 'i' } },
        { law: { $regex: search, $options: 'i' } },
        { article: { $regex: search, $options: 'i' } },
        { number: { $regex: search, $options: 'i' } },
      ];

      if (client_id) {
        const clientObjectId = oid(client_id);
        condition = {
          ...condition,
          client_id: clientObjectId,
          $or: searchConditions,
        };
      } else {
        condition = {
          ...condition,
          $or: searchConditions,
        };
      }

    } else if (client_id) {
      condition = {
        ...condition,
        client_id: oid(client_id)
      };
    }

    const pipeline = [
      { $match: condition },
      {
        $facet: {
          crimes: [
            { $sort: { [sortBy]: sortOrder !== undefined ? sortOrder : 1 } },
            { $skip: offset || 0 },
            { $limit: limit || 10 },
            {
              $project: {
                _id: 1,
                name: 1,
                description: 1,
                lawNumber: 1,
                law: 1,
                article: 1,
                number: 1
              }
            }
          ],
          totalRecords: total ? [
            { $count: "count" }
          ] : []
        }
      }
    ];

    const result = await getItemsAggregate({ collection: 'crime', pipeline })

    return {
      crimes: result[0].crimes,
      totalRecords: total ? (result[0].totalRecords[0]?.count || 0) : 0
    };
  };

  const audiencesQueryWithOffset = async ({ offset, limit, search, sortBy, sortOrder, client_id, workers, type }) => {
    const filter = {
      client_id: oid(client_id),
      deleted: { $ne: true }
    }

    if (workers && workers.length) { filter.institutionServant = { "$in": workers.map(worker => oid(worker)) } }
    if (type) filter.type = type

    const pipeline = [
      {
        $match: filter
      },
      {
        $lookup: {
          from: 'worker',
          localField: 'institutionServant',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                _id: 0,
                name: 1
              }
            }
          ],
          as: 'institutionServantName'
        }
      },
      {
        $lookup: {
          from: "location",
          localField: "area",
          foreignField: "_id",
          as: "areaName",
          pipeline: [
            {
              $project: {
                _id: 0,
                location: 1
              }
            }
          ]
        }
      },
      {
        $addFields: {
          institutionServantName: {
            $arrayElemAt: ["$institutionServantName.name", 0],
          },
          areaName: {
            $arrayElemAt: ["$areaName.location", 0],
          },
        },
      },
    ]

    if (search) {
      pipeline.push(
        {
          $match: {
            $or: [ 
              { institution: { $regex: search, $options: 'i' } },
              { institutionServantName: { $regex: search, $options: 'i' } },
              { areaName: { $regex: search, $options: 'i' } },
              { topic: { $regex: search, $options: 'i' } }
            ]
          }
        }
      )
    }

    pipeline.push(
      {
        $facet: {
          totalCount: [
            {
              $group: {
                _id: null,
                total: {
                  $sum: 1
                }
              }
            },
            {
              $project: {
                _id: 0,
                total: 1
              }
            }
          ],
          paginatedResults: [
            {
              $sort: {
                [sortBy]: sortOrder || 1,
                _id: sortOrder || 1
              }
            },
            {
              $skip: offset || 0
            },
            {
              $limit: limit || 10
            }
          ]
        }
      }
    )
    
    const audiences = await getItemsAggregate({ collection: 'audience', pipeline })
    
    return {
      audiencesPaginated: audiences[0].paginatedResults,
      totalCount: audiences[0].totalCount[0]?.total || 0
    }
  }

  const locationsQueryWithOffset = async ({ query, offset, limit, total, search, sortBy, sortOrder, client_id = null }) => {
    let condition = query || {};
    condition.deleted = { $ne: true };
    condition.onlyDropdownOption = { $ne: true };

    if (search) {
      const searchConditions = [
        { location: { $regex: search, $options: 'i' } },
        { zone: { $regex: search, $options: 'i' } },
        { agency: { $regex: search, $options: 'i' } },
      ];

      if (client_id) {
        const clientObjectId = oid(client_id);
        condition = {
          ...condition,
          client_id: clientObjectId,
          $or: searchConditions,
        };
      } else {
        condition = {
          ...condition,
          $or: searchConditions,
        };
      }

    } else if (client_id) {
      condition = {
        ...condition,
        client_id: oid(client_id)
      };
    }

    const pipeline = [
      { $match: condition },
      {
        $facet: {
          locations: [
            { $sort: { [sortBy]: sortOrder !== undefined ? sortOrder : 1 } },
            { $skip: offset || 0 },
            { $limit: limit || 10 },
            {
              $project: {
                _id: 1,
                location: 1,
                zone: 1,
                agency: 1
              }
            }
          ],
          totalRecords: total ? [
            { $count: "count" }
          ] : []
        }
      }
    ];

    const result = await getItemsAggregate({ collection: 'location', pipeline })

    return {
      locations: result[0].locations,
      totalRecords: total ? (result[0].totalRecords[0]?.count || 0) : 0
    };
  };

  const pendingConfirmationsQueryWithOffset = async ({ offset, limit, total, search, sortBy, sortOrder, worker_id = '' }) => {    
    let totalRecords = 0;
    let totalRecordsCount = []

    
    let pipeline = [
      {
        $match: {
          pending: true,
          supervisor: oid(worker_id)
        }
      },
      {
        $lookup: {
          from: 'worker',
          localField: 'worker',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                name: 1
              }
            }
          ],
          as: 'workerName'
        }
      },
      {
        $lookup: {
          from: 'process',
          localField: 'process',
          foreignField: '_id',
          pipeline: [
            {
              $project: {
                name: 1
              }
            }
          ],
          as: 'processName'
        }
      },
      {
        $project: {
          date: 1,
          workerName: 1,
          processName: 1
        }
      },
    ]

    if (search) {
      pipeline.push(
        {
          $match: {
            $or: [
              {
                workerName: {
                  $elemMatch: {
                    name: {
                      $regex: search,
                      $options: 'i'
                    }
                  }
                }
              },
              {
                processName: {
                  $elemMatch: {
                    name: {
                      $regex: search,
                      $options: 'i'
                    }
                  }
                }
              }
            ]
          }
        }
      )
    }

    totalRecordsCount = await getItemsAggregate({ collection: 'confirmation', pipeline })

    totalRecords = totalRecordsCount.length;

    pipeline.push(
      {
        $sort: {
          [sortBy]: sortOrder || 1,
          _id: sortOrder || 1
        }
      },
      {
        $skip: offset || 0
      },
      {
        $limit: limit || 10
      }
    )
    
    const pendingConfirmations = await getItemsAggregate({ collection: 'confirmation', pipeline })

    return {
      pendingConfirmations,
      totalRecords
    }
    
  };

  const rolesQueryWithOffset = async ({ query, offset, limit, total, search, sortBy, sortOrder, client_id = '' }) => {
    let condition = query || {};
    condition.deleted = { $ne: true };

    if (search) {
      const searchConditions = [
        { name: { $regex: search, $options: 'i' } },
        { code: { $regex: search, $options: 'i' } },
        { description: { $regex: search, $options: 'i' } }
      ];

      if (client_id !== '') {
        const clientObjectId = oid(client_id);
        condition = {
          ...condition,
          client_id: clientObjectId,
          $or: searchConditions
        };
      } else {
        condition = {
          ...condition,
          $or: searchConditions
        };
      }

    } else if (client_id !== '') {
      condition = {
        ...condition,
        client_id: oid(client_id)
      };
    }

    const pipeline = [
      { $match: condition },
      {
        $facet: {
          roles: [
            { $sort: { [sortBy]: sortOrder !== undefined ? sortOrder : 1 } },
            { $skip: offset || 0 },
            { $limit: limit || 10 },
            {
              $project: {
                _id: 1,
                name: 1,
                code: 1,
                description: 1,
                responsibilities: 1,
                qualifications: 1
              }
            }
          ],
          totalRecords: total ? [
            { $count: "count" }
          ] : []
        }
      }
    ];

    const result = await getItemsAggregate({ collection: 'role', pipeline })

    return {
      roles: result[0].roles,
      totalRecords: total ? (result[0].totalRecords[0]?.count || 0) : 0
    };
  };

  const workersQueryWithOffset = async ({ query, offset, limit, total, search, sortBy, sortOrder, supervisor, client_id = '', location, roles, privileges, company }) => {
    let condition = query || {};
    condition.deleted = { $ne: true };
    condition.onlyDropdownOption = { $ne: true };

    if (supervisor)
      condition.supervisors = oid(supervisor);

    if (search) {
      const searchConditions = [
        { name: { $regex: search, $options: 'i' } },
        { email: { $regex: search, $options: 'i' } }
      ];

      if (client_id !== '') {
        const clientObjectId = oid(client_id);
        condition = {
          ...condition,
          client_id: clientObjectId,
          $or: searchConditions
        };
      } else {
        condition = {
          ...condition,
          $or: searchConditions
        };
      }

    } else if (client_id !== '') {
      condition = {
        ...condition,
        client_id: oid(client_id)
      };
    }

    if (location && location.length) {
      condition.locations = {
        $in: location.map(l => oid(l))
      };
    }

    if (roles && roles.length) {
      condition.roles = {
        $in: roles.map(r => oid(r))
      };
    }

    if (privileges && privileges.length) {
      condition.privileges = {
        $in: privileges
      };
    }

    if (company && company.length) {
      condition.company = {
        $in: company.map(c => oid(c))
      };
    }

    const pipeline = [
      { $match: condition },
      {
        $facet: {
          workers: [
            { $sort: { [sortBy]: sortOrder !== undefined ? sortOrder : 1 } },
            { $skip: offset || 0 },
            { $limit: limit || 10 },
            {
              $lookup: {
                from: 'worker_permission_override',
                localField: '_id',
                foreignField: 'worker_id',
                as: 'permissionOverrideData'
              }
            },
            {
              $lookup: {
                from: 'role',
                localField: 'roles',
                foreignField: '_id',
                as: 'rolesData',
                pipeline: [
                  { $project: { _id: 0, name: 1 } }
                ]
              }
            },
            {
              $lookup: {
                from: 'company',
                localField: 'company',
                foreignField: '_id',
                as: 'companyData',
                pipeline: [
                  { $project: { _id: 0, name: 1 } }
                ]
              }
            },
            {
              $addFields: {
                hasCustomPermissions: { $gt: [{ $size: '$permissionOverrideData' }, 0] }
              }
            },
            {
              $project: {
                _id: 1,
                name: 1,
                email: 1,
                roles: 1,
                rolesData: 1,
                supervisors: 1,
                privileges: 1,
                locations: 1,
                hasCustomPermissions: 1,
                companyData: 1
              }
            }
          ],
          workersTotal: [
            {
              $lookup: {
                from: "location",
                localField: "locations",
                foreignField: "_id",
                as: "locationsData",
                pipeline: [
                  { $project: { _id: 0, location: 1 } }
                ]
              }
            },
            {
              $lookup: {
                from: "role",
                localField: "roles",
                foreignField: "_id",
                as: "rolesData",
                pipeline: [
                  { $project: { _id: 0, name: 1 } }
                ]
              }
            },
            {
              $lookup: {
                from: "worker",
                localField: "supervisors",
                foreignField: "_id",
                as: "supervisorsData",
                pipeline: [
                  { $project: { _id: 0, name: 1 } }
                ]
              }
            },
            {
              $lookup: {
                from: "company",
                localField: "company",
                foreignField: "_id",
                as: "companyData",
                pipeline: [
                  { $project: { _id: 0, name: 1 } }
                ]
              }
            },
            {
              $project: {
                _id: 0,
                email: 1,
                name: 1,
                privileges: 1,
                locationsData: 1,
                rolesData: 1,
                supervisorsData: 1,
                companyData: 1
              }
            }
          ],
          totalRecords: total ? [
            { $count: "count" }
          ] : []
        }
      }
    ];

    const result = await getItemsAggregate({ collection: 'worker', pipeline })

    return {
      workers: result[0].workers,
      workersTotal: result[0].workersTotal,
      totalRecords: total ? (result[0].totalRecords[0]?.count || 0) : 0
    };
  };

  const commitmentReport = async ({ clientId, restrictToOwn, userId, locations, roles, processes, workers, date_gte, date_lt, processTypeFilter, companyFilter, idFilter }) => {
    const userObjectId = oid(userId)

    const workerFilter = {
      deleted: { $ne: true },
    }
    if (clientId) workerFilter.client_id = oid(clientId)

    if (locations && locations.length) workerFilter.locations = { "$in": locations.map(location => oid(location)) }

    if (roles && roles.length) workerFilter.roles = { "$in": roles.map(role => oid(role)) }

    if (workers && workers.length) workerFilter._id = { "$in": workers.map(worker => oid(worker)) }

    const initialConfirmationFilter = {
      pending: { $ne: true },
      $and: [ { date: { $gte: date(date_gte) } }, { date: { $lt: date(date_lt) } } ]
    }

    if (processes && processes.length) initialConfirmationFilter.process = { "$in": processes.map(process => oid(process)) }

    // Condiciones finales
    const conditions = []

    // Process type filter
    if (processTypeFilter && processTypeFilter.length) {
      conditions.push({
        $or: processTypeFilter.map(codePrefix => ({
          'process.code': { $regex: `^${codePrefix}` }
        }))
      })
    }

    // Privileges filter
    if (restrictToOwn) {
      conditions.push({
        $or: [
          { 'process.responsibles': userObjectId },
          { 'process.leadResponsibles': userObjectId },
          { 'process.evaluator': userObjectId },
        ]
      })
    }

    if (companyFilter?.length > 0) {
      conditions.push({ 'process.company': { $in: companyFilter.map(e => oid(e)) } })
    }

    if (idFilter?.length > 0) {
      conditions.push({ 'process.id': { $in: idFilter.map(e => oid(e)) } })
    }

    // Armar el match final
    const finalConfirmationFilter = conditions.length
      ? { $and: conditions }
      : {}

    const pipeline = [
      {
        $match: workerFilter
      },
      {
        $project: {
          name: 1,
        },
      },
      {
        $lookup: {
          from: "confirmation",
          localField: "_id",
          foreignField: "worker",
          pipeline: [
            {
              $match: initialConfirmationFilter
            },
            {
              $lookup: {
                from: "process",
                localField: "process",
                foreignField: "_id",
                pipeline: [
                  {
                    $project: {
                      name: 1,
                      code: 1,
                      responsibles: 1,
                      leadResponsibles: 1,
                      evaluator: 1,
                      company: 1,
                      id: 1
                    }
                  },
                  {
                    $addFields: {
                      _id: { $toString: "$_id" }
                    },
                  }
                ],
                as: "process"
              }
            },
            { $addFields: { process: { $arrayElemAt: ["$process", 0] } } },
            {
              $match: finalConfirmationFilter
            },
            {
              $sort: {
                date: -1,
                _id: -1
              },
            },
            {
              $addFields: {
                processId: "$process._id",
                processCode: "$process.code",
                processName: "$process.name",
              },
            },
            {
              $project: {
                _id: 1,
                processId: 1,
                processCode: 1,
                processName: 1,
                activities: 1,
                score: 1,
                total: 1,
              }
            },
            {
              $lookup: {
                from: "improvement",
                localField: "_id",
                foreignField: "confirmation",
                pipeline: [
                  {
                    $project: {
                      _id: 1,
                      stage: 1,
                      activity: 1,
                      behaviour: 1,
                      dueDate: 1,
                      createdAt: 1,
                      linkedBehaviors: 1
                    }
                  },
                  {
                    $sort: {
                      _id: -1
                    }
                  }
                ],
                as: "cases"
              }
            },
            {
              $addFields: {
                _id: { $toString: "$_id" }
              },
            }
          ],
          as: "confirmationsData",
        },
      },
      {
        $addFields: {
          totalScore: {
            $sum: "$confirmationsData.score",
          },
          totalTotal: {
            $sum: "$confirmationsData.total",
          },
        },
      },
      {
        $match: {
          totalTotal: {
            $ne: 0
          }
        }
      },
      {
        $addFields: {
          averageAdherence: {
            $divide: [ "$totalScore", "$totalTotal" ],
          },
          _id: { $toString: "$_id" }
        },
      },
      {
        $sort: {
          averageAdherence: 1,
        },
      }
    ]

    const commitments = await getItemsAggregate({ collection: 'worker', pipeline })

    return {
      commitments,
    }
  }
  
  return {
    processesQueryWithOffset,
    complaintsQueryWithOffset,
    getLastCode,
    casesQueryWithOffset,
    confirmationPlanningQueryWithOffset,
    crimesQueryWithOffset,
    audiencesQueryWithOffset,
    locationsQueryWithOffset,
    pendingConfirmationsQueryWithOffset,
    rolesQueryWithOffset,
    workersQueryWithOffset,
    commitmentReport,
  }
}